<script>
  // import { mapState } from 'vuex'
  export default {
    name: 'Textarea',
    props: ['form', 'placeholder', 'rules', 'field', 'label', 'maxlength', 'id', 'type', 'dense'],
    computed: {
      model: {
        get() {
          return this.$store.state[this.form][this.field]
        },
        set(v) {
          this.$store.dispatch(`${ this.form }/SET_FIELD`, { key: this.field, value: v })
        },
      },
    },
  }
</script>

<template>
  <v-textarea
    outlined
    class="py-0 my-0"
    v-model="model"
    :dense="dense"
    :id="id"
    :placeholder="placeholder"
    :rules="rules"
    :label="label"
    :type ="type || 'text'"
  ></v-textarea>
</template>
